import { Inject, Injectable, Injector } from '@angular/core';
import { map, Observable } from 'rxjs';
import { PaginatorResponse } from '../../../models/login.models';
import {
  ProductBoxRequest,
  ProductDiscountRequest,
  ProdutoByIdRequest,
  ProdutoRequestInAllBranches,
  ProdutoResponse,
  ProdutoResponseInAllBranches,
  ProdutoSearchRequest,
  ProdutoSearchResponse,
} from '../../../models/product.models';
import { UtilsBaseApiService } from '@brunsker/libs/core/utils/base-api';
import { ENVIRONMENT_TOKEN, Environment } from '@brunsker/libs/core/utils/http-log-interceptor/src';
import { Produtos } from '../../domain/home/models/home.models';
import { SelectClientService } from '@brunsker/libs/portal-do-vendedor/utils/portal-vendedor-api';

@Injectable({
  providedIn: 'root',
})
export class NewApiProductService extends UtilsBaseApiService<NewApiProductService> {
  readonly ESTOQUE_CONTEXT = 'estoque';
  readonly SEARCH_CONTEXT = 'search';
  readonly DESCONTO_CONTEXT = 'maximoDesconto';
  readonly MAIOR_ESTOQUE_CONTEXT = 'maiorEstoque';
  readonly ULTIMA_ENTRADA_CONTEXT = 'ultimaEntrada';
  readonly LANCAMENTOS_CONTEXT = 'lancamentos';
  readonly PROMOCOES_CONTEXT = 'promocao';

  constructor(
    private readonly selectClientService: SelectClientService,
    @Inject(ENVIRONMENT_TOKEN) readonly environment: Environment,
    override readonly injector: Injector
  ) {
    super('produto', injector, environment.BASE_API_URL);
  }

  getInformationProduct(
    request: ProdutoSearchRequest
  ): Observable<PaginatorResponse<ProdutoSearchResponse>> {
    if (request.PESQUISA && request.PESQUISA?.length >= 1) {
      request.PESQUISA = request.PESQUISA?.toString();
    }
    if (!request.FILIAL) {
      request.FILIAL = +sessionStorage.getItem('filial')!;
    }
    return this.httpClient.post<PaginatorResponse<ProdutoSearchResponse>>(
      `${this.BASE_URL}${this.CONTEXT}/${this.SEARCH_CONTEXT}`,
      request
    );
  }

  getProductById(request: ProdutoByIdRequest): Observable<ProdutoResponse> {
    return this.httpClient
      .get<ProdutoResponse>(
        `${this.BASE_URL}${this.CONTEXT}/find-product?` + this.getQueryString(request)
      );
  }

  getProductInAllBranches(request: ProdutoRequestInAllBranches) {
    const data = {
      ...request,
      filial: this.selectClientService.getCliente()?.filial ?? 1,
      codCli: this.selectClientService.getCliente()?.id
    }
    return this.httpClient.get<ProdutoResponseInAllBranches[]>(
      `${this.BASE_URL}${this.CONTEXT}/${this.ESTOQUE_CONTEXT}?${this.getQueryString(data)}`
    );
  }

  getProductDiscount(request: ProductDiscountRequest) {
    const getQueryString = this.getQueryString(request);

    return this.httpClient.get<{
      percdesc: number;
      descautomatico: string;
      iD_DESCONTO: number;
    }>(
      `${this.BASE_URL}${this.CONTEXT}/${this.DESCONTO_CONTEXT}?${getQueryString}`
    );
  }

  getLargeStockProducts(productBox:ProductBoxRequest) {
    return this.httpClient.get<Produtos[]>(
      `${this.BASE_URL}${this.CONTEXT}/${this.MAIOR_ESTOQUE_CONTEXT}?${this.getQueryString(productBox)}`
    );
  }

  getLastEnterProducts(productBox:ProductBoxRequest) {
    return this.httpClient.get<Produtos[]>(
      `${this.BASE_URL}${this.CONTEXT}/${this.ULTIMA_ENTRADA_CONTEXT}?${this.getQueryString(productBox)}`
    );
  }

  getNewProducts(productBox:ProductBoxRequest) {
    return this.httpClient.get<Produtos[]>(
      `${this.BASE_URL}${this.CONTEXT}/${this.LANCAMENTOS_CONTEXT}?${this.getQueryString(productBox)}`
    );
  }

  getPromotionsProducts(productBox:ProductBoxRequest) {
    return this.httpClient.get<Produtos[]>(
      `${this.BASE_URL}${this.CONTEXT}/${this.PROMOCOES_CONTEXT}?${this.getQueryString(productBox)}`
    );
  }
}
